// This example shows you how to set up React Stripe.js and use Elements.
// Learn how to accept a payment using the official Stripe docs.
// https://www.stripe.com/docs/payments/integration-builder

import React, { useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { plans } from "./constants";
import Plan from "./components/Plan";
import Info from "./components/Info";
import Discount from "./components/Discount";
import PaymentModal from "./components/PaymentModal";

import "./css/normalize.css";
import "./css/global.css";

import logo from "./assets/logo.png";

const App = () => {
  const [isSmallWindow, setIsSmallWindow] = useState();
  const [choosenPlan, setChoosenPlan] = useState(null);
  const [isOpenUserModal, setIsOpenUserModal] = useState(false);
  const [currentPlanIndex, setCurrentPlanIndex] = useState(0);

  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const isSuccess = query.get("isSuccess");

  useLayoutEffect(() => {
    function updateSize() {
      setIsSmallWindow(window.innerWidth <= 530);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <div className="AppWrapper">
      <Info />
      {isSmallWindow ? (
        <>
          <div className="planWrapper">
            <h2 className="subTitle">{plans[currentPlanIndex].planName}</h2>
            <div className="namesWrapper">
              {plans.map(({ smallName }, index) => (
                <div
                  key={smallName}
                  className={`${
                    index === currentPlanIndex ? "smallNameActive" : "smallName"
                  }`}
                  onClick={() => {
                    setCurrentPlanIndex(index);
                    setChoosenPlan(null);
                  }}
                >
                  {smallName}
                </div>
              ))}
            </div>
            <div className="scrollContainer">
              <div
                className="smallPlansWrapper"
                style={{ width: 266 * plans[currentPlanIndex].items.length }}
              >
                {plans[currentPlanIndex].items.map((plan) => (
                  <Plan
                    key={plan.id}
                    plan={plan}
                    isActive={choosenPlan?.id === plan.id}
                    setChoosenPlan={setChoosenPlan}
                    isOpenUserModal={isOpenUserModal}
                    setIsOpenUserModal={setIsOpenUserModal}
                  />
                ))}
              </div>
            </div>
            <div className="expiry small">
              Ημερομηνία λήξης {plans[currentPlanIndex].expiryDate}
            </div>
          </div>
        </>
      ) : (
        <>
          {plans.map(({ planName, items, expiryDate }, index) => (
            <div key={planName} className={`${!index ? "planWrapper" : ""}`}>
              {!index && (
                <h1 className="subTitle big">
                  Δοκιμαστικές και επί πληρωμή συνδρομές 2022
                </h1>
              )}
              <h2 className="subTitle">{planName}</h2>
              <section className="infoSection">
                {items.map((plan) => (
                  <Plan
                    key={plan.id}
                    plan={plan}
                    isActive={choosenPlan?.id === plan.id}
                    setChoosenPlan={setChoosenPlan}
                    isOpenUserModal={isOpenUserModal}
                    setIsOpenUserModal={setIsOpenUserModal}
                  />
                ))}
              </section>
              <div className="expiry">Ημερομηνία λήξης {expiryDate}</div>
            </div>
          ))}
        </>
      )}

      <Discount />
      <PaymentModal isSuccess={isSuccess} />

      <div className="footer">
        <img src={logo} alt="logo" />
      </div>
    </div>
  );
};

export default App;
